import React, { useState } from 'react'
import styled from 'styled-components'

// utils
import { getComma, getMaskingStr } from '../../utils'
import { phoneFormatter } from '../../utils/regexUtil'

// styles
import colors from '../../styles/colors'

const DetailItem = ({
  orderList,
  hiddenOrder,
  isPickup,
  setOrderHistoryItem,
  isComplete,
}) => {
  const orderCancelled = orderList?.OrderStatus === 307 // 주문취소
  const orderTypeDelivery = orderList?.orderType === 'D' // 배달유무(배달정보)

  const [isDeliveryVisible, setIsDeliveryVisible] = useState(false)

  const handleToggleDelivery = (item, isOpen) => {
    setIsDeliveryVisible(!isDeliveryVisible)

    // 상세주소를 확인할 때만 로그 저장
    if (!isOpen) {
      setOrderHistoryItem(item)
    }
  }

  // console.log('$$ detail item', orderList)
  // console.log(
  //   '$$ detail item 11',
  //   JSON.parse(orderList?.orderGoodsList),
  //   isPickup,
  // )

  return (
    <>
      <DetailBoxWrap>
        <DetailBoxTit>주문정보</DetailBoxTit>
        <DetailBox orderCancelled={orderCancelled}>
          {JSON.parse(orderList?.orderGoodsList)?.map((orderGoods, i) => {
            // console.log('$$ detail item 22', orderGoods)

            return (
              <div key={i}>
                <DetailBtwBox>
                  <DetailTxt>{`${orderGoods.goodsName}${
                    orderGoods.ea > 1 ? ` X ${orderGoods.ea}` : ''
                  }`}</DetailTxt>
                  <DetailPrice>
                    {getComma(orderGoods.salePrice * orderGoods.ea)}원
                  </DetailPrice>
                </DetailBtwBox>
                {orderGoods.optionList &&
                  orderGoods.optionList.length > 0 &&
                  orderGoods.optionList.map(
                    (option, k) =>
                      option?.optionGoodsList &&
                      option?.optionGoodsList.map((item, i) => (
                        <>
                          <DetailBtwBox className="ms-2" key={k}>
                            <DetailAddTxt>{`${item?.goodsName}${
                              item.ea > 1 ? ` X ${item.ea}` : ''
                            }`}</DetailAddTxt>
                            <DetailAddPrice>
                              {getComma(item?.salePrice * item.ea)}원
                            </DetailAddPrice>
                          </DetailBtwBox>
                        </>
                      )),
                  )}
                {/* {orderGoods.optionList &&
                  orderGoods.optionList.length > 0 &&
                  orderGoods.optionList[i]?.optionGoodsList?.map(
                    (option, k) => (
                      <DetailBtwBox className="ms-2" key={k}>
                        <DetailAddTxt>{option.goodsName}</DetailAddTxt>
                        <DetailAddPrice>
                          {getComma(option.salePrice)}원
                        </DetailAddPrice>
                      </DetailBtwBox>
                    ),
                  )} */}
              </div>
            )
          })}
          <DetailBtwBox className="borderLineBold">
            <DetailTxt>총 결제금액</DetailTxt>
            <DetailPrice>{getComma(orderList.orderMoney)}원</DetailPrice>
          </DetailBtwBox>
        </DetailBox>
      </DetailBoxWrap>

      {orderCancelled ? (
        <DetailBoxWrap>
          <DetailBoxTit>결제정보</DetailBoxTit>
          <DetailBox>
            <DetailBtwBox marginBottom={'0'}>
              <DetailTxt>취소</DetailTxt>
              <DetailPrice>{orderList.CancelReason ?? ''}</DetailPrice>
            </DetailBtwBox>
          </DetailBox>
        </DetailBoxWrap>
      ) : (
        <DetailBoxWrap>
          <DetailBoxTit>정산정보</DetailBoxTit>
          <DetailBox>
            <DetailBtwBox>
              <DetailTxt>판매금액</DetailTxt>
              <DetailPrice>{getComma(orderList.orderMoney)}원</DetailPrice>
            </DetailBtwBox>
            {!isPickup && (
              <DetailBtwBox>
                <DetailTxt>배달료</DetailTxt>
                <DetailPrice>{getComma(orderList.deliveryFee)}원</DetailPrice>
              </DetailBtwBox>
            )}

            <DetailBtwBox className="borderLineBold">
              <DetailTxt>정산금액</DetailTxt>
              <DetailPrice>
                {getComma(
                  parseInt(orderList.payMoney),
                  // +
                  //   parseInt(orderList.deliveryFee),
                )}
                원
              </DetailPrice>
            </DetailBtwBox>
          </DetailBox>
        </DetailBoxWrap>
      )}
      {orderTypeDelivery && (
        <DetailBoxWrap>
          <DetailBoxTit>배달정보</DetailBoxTit>
          <DetailBox>
            <DetailPrice>{orderList?.address1 ?? ''}</DetailPrice>
            {isDeliveryVisible && (
              <>
                <DetailAddress>
                  <span>
                    {!hiddenOrder.includes(orderList?.ReceiptId)
                      ? orderList?.address2 ?? ''
                      : '*****'}
                  </span>
                  <span>
                    {!hiddenOrder.includes(orderList?.ReceiptId)
                      ? phoneFormatter(orderList?.receiverHp) ?? ''
                      : '*****'}
                  </span>
                </DetailAddress>
              </>
            )}
            {/* {!isComplete && ( */}
            <AddressDetailBtn>
              <button
                className="addressBtn"
                type="button"
                onClick={() =>
                  handleToggleDelivery(orderList, isDeliveryVisible)
                }
              >
                {isDeliveryVisible ? '상세정보 숨기기' : '상세정보 확인하기'}
              </button>
            </AddressDetailBtn>
            {/* )} */}
          </DetailBox>
        </DetailBoxWrap>
      )}
    </>
  )
}

export default DetailItem

const DetailBoxWrap = styled.article`
  width: 100%;
  padding: 25px 20px;
  background-color: #f3f3f3;
  border-radius: 8px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-top: 2px;
`
const DetailBoxTit = styled.h4`
  font-size: 16px;
  font-weight: 700;
  color: #000;
`
const DetailBox = styled.div`
  display: flex;
  flex-direction: column;
  width: 50%;
  ${(props) => props.orderCancelled && 'opacity: 0.3;'}
  .borderLine {
    border-bottom: 1px solid #e5e5e5;
    padding-bottom: 15px;
  }
  .borderLineBold {
    border-top: 1px solid #000;
    padding-top: 15px;
  }
`

const DetailBtwBox = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  /* margin-bottom: 15px;  */
  margin-bottom: ${(props) =>
    props.marginBottom ? props.marginBottom + 'px' : '15px'};
`

const AddressDetailBtn = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  text-align: center;
  width: 160px;
  height: 25px;
  margin: 10px 0;

  .addressBtn {
    background-color: ${colors.mainG};
    color: #fff;
    border-radius: 7px;
    width: 100%;
    height: 100%;
  }
`

const DetailTxt = styled.h4`
  font-size: 16px;
  color: #000;
`
const DetailPrice = styled.p`
  font-size: 16px;
  font-weight: 700;
  color: #000;
`
const DetailAddTxt = styled.h4`
  font-size: 13px;
  color: #8a8a8a;
`
const DetailAddPrice = styled.p`
  font-size: 13px;
  color: #000;
`

const DetailAddress = styled.div`
  display: flex;
  flex-direction: column;
  font-size: 16px;
  color: #000;

  span {
    margin-top: 10px;
  }
`
